import "./EstimateProject.css";
import EstimateBoy from "./../../../Assets/EstimateBoy.webp";
import EstimateP from "./../../../Assets/EstimateP.webp";
import estimatePhone from "./../../../Assets/estimatePhone.png";
import React from "react";

function EstimateProject({ scrollToAppointment }) {
  return (
    <div className="Es-layout1">
      <img src={EstimateP} width="1920" height="1060" alt="" className="Es-layout" loading="lazy" />
      <div className="Es-container">
        <img src={EstimateBoy} width="400" height="548" alt="" className="Es-layout2" loading="lazy" />
        <div className="Es-layout3">
          <img src={estimatePhone} width="70" height="70" alt="" className="Es-layout4 estimate-image" loading="lazy" />
          <h2 className="Es-heading">Have a Project in Mind? Let&rsquo;s Talk</h2>
          <a className="Es-content2 Es-phone" href="tel:+923249925737">
            +92 324 9925737
          </a>
          <p className="Es-content3">
            Have any idea or project in mind? Call us or schedule an
            appointment. Our representative will reply to you shortly.
          </p>
          <button
            type="button"
            className="Es-button"
            onClick={scrollToAppointment}
          >
            Estimate your Project
          </button>
        </div>
      </div>
    </div>
  );
}

export default EstimateProject;